var map = {
	"./article.png": 44,
	"./bg.PNG": 853,
	"./bri-web.png": 776,
	"./cv_aurelreyna.pdf": 455,
	"./datacamp_brown.png": 285,
	"./datacamp_white.png": 454,
	"./dictionary.png": 814,
	"./download_brown.png": 272,
	"./download_white.png": 155,
	"./email_brown.png": 981,
	"./email_white.png": 617,
	"./github_brown.png": 837,
	"./github_white.png": 655,
	"./linkedin_brown.png": 70,
	"./linkedin_white.png": 718,
	"./logo.svg": 582,
	"./pfp.jpg": 657,
	"./poem.png": 592,
	"./shannon.png": 879,
	"./shecodes_brown.png": 541,
	"./shecodes_white.png": 96,
	"./weather.png": 564,
	"./worldclock.png": 746
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 327;